import {
    SET_BASKET_COMMENT,
    SET_BASKET_PHOTO,
    SET_IMAGES_STYLE,
    SET_PRICE_ON_PHOTO,
    SET_SHOW_DESCRIPTION,
    SET_TIME_FORMAT,
    SET_WEBVIEW_SETTINGS,
    SET_HOME_SCROLL,
    SET_SHOW_AGREE_TEXT,
    SET_LANGUAGE,
    SET_SEARCH_WIDGET,
    SET_OVERLAY,
    SET_CLIENT_INFO,
    SET_ERROR,
    SET_LAZY_COMPONENT,
    SET_PROMOCODE_AVAILABLE,
    SET_SHOW_MADE_VIA_DIGARSON,
    SET_FORCE_GUARD,
    SET_WHITE_LABEL,
    SET_GTM_TAG,
    SET_BLOCK_MODAL_ENABLED,
    SET_CONTACTLESS_MODE,
    SET_CUTLERY,
    SET_CHECK_IOS,
    SET_SHOP_MODE
} from '@/store/mutations.type'

import {
    GET_CONFIG,
    ENABLE_OVERLAY,
    DISABLE_OVERLAY,
    SET_GLOBAL_ERROR
} from '@/store/actions.type'

import Noty from 'noty'
import Vue from 'vue'
import axios from 'axios'
import api from '@/api'


const IMAGES_WIDE = 0
const IMAGES_SQUARE_LEFT = 1
const IMAGES_SQUARE_RIGHT = 4
const IMAGES_SQUARE_MINIATURE = 2
const IMAGES_VERTICAL = 3

const state = {
    basketComment: false,
    language: 'ru',
    basketPhoto: false,
    priceOnPhoto: false,
    imagesStyle: IMAGES_WIDE,
    showDescription: true,
    timeFormat12: false,
    showCustomBasketText: false,
    showAgreeText: true,
    searchWidget: false,
    promocodeAvailable: false,
    blockModalEnabled: false,
    cutlery: false,
    homeScroll: 0,
    overlay: true,
    clientInfo: null,
    error: null,
    gtmTag: null,
    showMadeViaDigarson: false,
    forceGuard: false,
    enableOrder: true,
    enable_online_payment: false,
    contactlessMode: false,
    thx_page: null,
    whiteLabel: {
        url: null,
        logo: null,
        footerText: null
    },
    lazyComponents: {
        basket: false
    },
    ecommercePopularCategoriesCount: null,
    ecommerceBasketAct: null,
    orientation: 0,
    checkIos: null,
    shopMode: null,
    categoryTileView: false,

    formNameRequired: false,
    formMainPhoneRequired: false,
    formEmailRequired: false,
    showCustomOrderText: false,

    showCallingWaiterButton: false,
    showCallingWaiterComment: false,
}

const getters = {
    checkIos(state) {
        return state.checkIos
    },
    thxPage(state) {
        return state.thx_page
    },
    overlay(state) {
        return state.overlay
    },
    clientInfo(state) {
        return state.clientInfo
    },
    error(state) {
        return state.error
    },
    lazyComponents(state) {
        return state.lazyComponents
    },
    timeFormat24(state) {
        return !state.timeFormat12
    },
    timeFormat12(state) {
        return state.timeFormat12
    },
    showMadeViaDigarson(state) {
        return state.showMadeViaDigarson
    },
    basketComment(state) {
        return state.basketComment
    },
    basketPhoto(state) {
        return state.basketPhoto
    },
    showCustomBasketText(state) {
        return state.showCustomBasketText
    },
    showAgreeText(state) {
        return state.showAgreeText
    },
    priceOnPhoto(state) {
        return state.priceOnPhoto
    },
    imagesStyle(state) {
        return state.imagesStyle
    },
    showDescription(state) {
        return state.showDescription
    },
    gtmTag(state) {
        return state.gtmTag
    },
    homeScroll(state) {
        return state.homeScroll
    },
    language(state) {
        return state.language
    },
    searchWidget(state) {
        return state.searchWidget
    },
    promocodeAvailable(state) {
        return state.promocodeAvailable
    },
    forceGuard(state) {
        return state.forceGuard
    },
    whiteLabel(state) {
        return state.whiteLabel
    },
    blockModalEnabled(state) {
        return state.blockModalEnabled
    },
    cutlery(state) {
        return state.cutlery
    },
    enableOrder(state) {
        return state.enableOrder
    },
    enableOnlinePayment(state) {
        return state.enable_online_payment
    },
    contactlessMode(state) {
        return state.contactlessMode
    },
    ecommercePopularCategoriesCount(state) {
        return state.ecommercePopularCategoriesCount
    },
    ecommerceBasketAct(state) {
        return state.ecommerceBasketAct
    },
    orientation(state) {
        return state.orientation
    },
    shopMode(state) {
        return state.shopMode
    },
    categoryTileView(state) {
        return state.categoryTileView
    },

    /**
     * @return {number}
     */
    IMAGES_WIDE() {
        return IMAGES_WIDE
    },
    /**
     * @return {number}
     */
    IMAGES_SQUARE_LEFT() {
        return IMAGES_SQUARE_LEFT
    },
    /**
     * @return {number}
     */
    IMAGES_SQUARE_RIGHT() {
        return IMAGES_SQUARE_RIGHT
    },
    /**
     * @return {number}
     */
    IMAGES_SQUARE_MINIATURE() {
        return IMAGES_SQUARE_MINIATURE
    },
    /**
     * @return {number}
     */
    IMAGES_VERTICAL() {
        return IMAGES_VERTICAL
    },
    formNameRequired: state => state.formNameRequired,
    formMainPhoneRequired: state => state.formMainPhoneRequired,
    formEmailRequired: state => state.formEmailRequired,
    showCustomOrderText: state => state.showCustomOrderText,

    showCallingWaiterButton: state => state.showCallingWaiterButton,
    showCallingWaiterComment: state => state.showCallingWaiterComment,
    
}


export const mutations = {
    [SET_WEBVIEW_SETTINGS](state, data) {
        state.imagesStyle = data.imagesStyle
        state.language = data.language
        state.basketComment = Boolean(data.basketComment)
        state.basketPhoto = Boolean(data.basketPhoto)
        state.showDescription = Boolean(data.showDescription)
        state.priceOnPhoto = Boolean(data.priceOnPhoto)
        state.searchWidget = Boolean(data.searchWidget)
        state.timeFormat12 = Boolean(data.timeFormat12)
        state.showAgreeText = Boolean(data.showAgreeText)
        state.showCustomBasketText = Boolean(data.showCustomBasketText)
        state.promocodeAvailable = Boolean(data.promocodeAvailable)
        state.forceGuard = Boolean(data.enabled_address_webview) || Boolean(data.hasDistricts) || Boolean(data.select_outlet_on_webview)
        state.showMadeViaDigarson = Boolean(!data.is_prototype)
            //state.whiteLabel = data.whiteLabel
        state.cutlery = data.cutlery
        state.enableOrder = Boolean(data.enable_online_order)
        state.orientation = data.orientation
        state.ecommerceBasketAct = data.ecommerce_basket_act
        state.ecommercePopularCategoriesCount = data.ecommerce_categories_count
        state.enable_online_payment = data.enable_online_payment
        state.thx_page = data.thx_page
        state.categoryTileView = Boolean(data.categoryTileView)

        state.formNameRequired = Boolean(data.formNameRequired)
        state.formMainPhoneRequired = Boolean(data.formMainPhoneRequired)
        state.formEmailRequired = Boolean(data.formEmailRequired)
        state.showCustomOrderText = Boolean(data.showCustomOrderText)
    
        state.showCallingWaiterButton = Boolean(data.showCallingWaiterButton)
        state.showCallingWaiterComment = Boolean(data.showCallingWaiterComment)
    
    },
    [SET_BASKET_COMMENT](state, data) {
        state.basketComment = Boolean(data)
    },
    [SET_IMAGES_STYLE](state, data) {
        state.imagesStyle = data
    },
    [SET_BASKET_PHOTO](state, data) {
        state.basketPhoto = Boolean(data)
    },
    [SET_SHOW_DESCRIPTION](state, data) {
        state.showDescription = Boolean(data)
    },
    [SET_PRICE_ON_PHOTO](state, data) {
        state.priceOnPhoto = Boolean(data)
    },
    [SET_PROMOCODE_AVAILABLE](state, data) {
        state.promocodeAvailable = Boolean(data)
    },
    [SET_SHOW_AGREE_TEXT](state, data) {
        state.showAgreeText = Boolean(data)
    },
    [SET_SHOW_MADE_VIA_DIGARSON](state, data) {
        state.showMadeViaDigarson = Boolean(data)
    },
    [SET_SEARCH_WIDGET](state, data) {
        state.searchWidget = Boolean(data)
    },
    [SET_TIME_FORMAT](state, data) {
        state.timeFormat12 = Boolean(data)
    },
    [SET_HOME_SCROLL](state, data) {
        state.homeScroll = Number(data)
    },
    [SET_LANGUAGE](state, data) {
        state.language = data
    },
    [SET_OVERLAY](state, data) {
        state.overlay = Boolean(data)
    },
    [SET_CLIENT_INFO](state, data) {
        state.clientInfo = data
    },
    [SET_WHITE_LABEL](state, data) {
        state.whiteLabel = data
    },
    [SET_ERROR](state, data) {
        state.error = data
    },
    [SET_FORCE_GUARD](state, data) {
        state.forceGuard = data
    },
    [SET_GTM_TAG](state, data) {
        state.gtmTag = data
    },
    [SET_BLOCK_MODAL_ENABLED](state, data) {
        state.blockModalEnabled = data
    },
    [SET_LAZY_COMPONENT](state, data) {
        state.lazyComponents[data.component] = data.state
    },
    [SET_CONTACTLESS_MODE](state, data) {
        state.contactlessMode = Boolean(data)
    },
    [SET_CUTLERY](state, data) {
        state.cutlery = Boolean(data)
    },
    [SET_CHECK_IOS](state, data) {
        state.checkIos = data
    },
    [SET_SHOP_MODE](state, data) {
        state.shopMode = data
    },
}

export const actions = {
    [ENABLE_OVERLAY](context) {
        if (!context.getters.overlay) {
            let overlay = document.getElementById('overlay')
            overlay.style.display = 'block'
            context.commit(SET_OVERLAY, true)
        }
    },

    [DISABLE_OVERLAY](context) {
        if (context.getters.overlay) {
            let overlay = document.getElementById('overlay')
            overlay.style.display = 'none'
            context.commit(SET_OVERLAY, false)
        }
    },

    [SET_GLOBAL_ERROR](context, data) {
        if (data.error && data.error.response) {
            if (data.error.response.data && data.error.response.data.notification === true) {
                if (data.error.response.data.template) {
                    new Noty({
                        type: 'error',
                        theme: 'sunset',
                        text: new Vue().text(data.error.response.data.template) || 'Internal error occurred. Please try again later',
                        timeout: 2000
                    }).show()
                } else if (data.error.response.data.message) {
                    new Noty({ type: 'error', theme: 'sunset', text: data.error.response.data.message, timeout: 2000 }).show()
                } else {
                    new Noty({
                        type: 'error',
                        theme: 'sunset',
                        text: data.defaultError || 'Internal error occurred. Please try again later',
                        timeout: 30000
                    }).show()
                }
            } else if (data.error.response.status >= 500) {
                new Noty({
                    type: 'error',
                    theme: 'sunset',
                    text: data.defaultError || 'Internal error occurred. Please try again later',
                    timeout: 30000
                }).show()
            } else if (data.error.response.data.errors) {

                if (data.error.response.data.errors[0].text) {
                    new Noty({
                        type: 'error',
                        theme: 'sunset',
                        text: data.error.response.data.errors[0].text || 'Internal error occurred. Please try again later',
                        timeout: 2000
                    }).show()
                }
            }
        }
        context.commit(SET_ERROR, data.error)
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}